// Shared palette for the board-pack charts, on Rare's design system.
//
// Products take their brand colours, so CRS is light blue, Candid mint and
// Hemisphere green wherever they appear: the dashboard, the reconciliation view
// and the PDF. Variants of one product take shades of its colour, and Vantage,
// which shares mint with Candid in the brand, takes gold so the two can be told
// apart on the same chart.
export const CHART_PALETTE = [
  "#3facc6", // CRS light blue
  "#50e3c2", // mint
  "#6dcc09", // Hemisphere green
  "#cfa77b", // gold
  "#119996", // teal deep
  "#1f5d74", // navy
  "#4a5b68", // slate 700
  "#b98c5c", // gold deep
  "#a7f0df", // mint light
  "#7d8b96", // slate 500
];

// Longest prefix wins, so "Candid ATS EH" is not coloured as plain Candid.
const PRODUCT_COLORS = [
  ["crs australia", "#1f5d74"],
  ["crs", "#3facc6"],
  ["contextual recruitment", "#3facc6"],
  ["candid ats eh", "#119996"],
  ["candid eh", "#119996"],
  ["candid essentials", "#a7f0df"],
  ["candid", "#50e3c2"],
  ["hemisphere education", "#a8e063"],
  ["staff - hemisphere", "#a8e063"],
  ["students - hemisphere", "#a8e063"],
  ["hemisphere", "#6dcc09"],
  ["vantage", "#cfa77b"],
  ["a&d", "#b98c5c"],
  ["attraction", "#b98c5c"],
];

// Status series read better with meaning-carrying colours than palette order.
// Matched case-insensitively against the series label.
export const SEMANTIC_COLORS = {
  red: "#c2192b",
  amber: "#f59e0b",
  green: "#6dcc09",
  churned: "#c2192b",
  retained: "#6dcc09",
  "initial term": "#3facc6",
  new: "#50e3c2",
  "new contract": "#50e3c2",
  won: "#6dcc09",
  lost: "#c2192b",
  "at contract": "#3facc6",
  active: "#6dcc09",
  paused: "#cfa77b",
  inactive: "#7d8b96",
  unknown: "#cccccc",
  other: "#cccccc",
  target: "#cfa77b",
};

export function productColor(label) {
  const key = String(label || "").trim().toLowerCase();
  const hit = PRODUCT_COLORS.find(([prefix]) => key.startsWith(prefix));
  return hit ? hit[1] : null;
}

export function colorFor(label, index, overrides = {}) {
  const key = String(label || "").trim().toLowerCase();
  if (overrides && overrides[label]) return overrides[label];
  if (overrides && overrides[key]) return overrides[key];
  if (SEMANTIC_COLORS[key]) return SEMANTIC_COLORS[key];
  return productColor(label) || CHART_PALETTE[index % CHART_PALETTE.length];
}
